import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Sunrise, Activity, ShieldAlert, Moon } from 'lucide-react';
const habits = [{
  icon: Droplets,
  title: 'Hidratación Inteligente',
  description: 'Aprende cuándo y cómo hidratarte para maximizar tu energía y metabolismo.'
}, {
  icon: Sunrise,
  title: 'Desayunos Optimizados',
  description: 'Descubre combinaciones que activan tu cuerpo desde la primera hora.'
}, {
  icon: Activity,
  title: 'Movimiento Diario',
  description: 'Incorpora actividad física sin necesidad de un gimnasio.'
}, {
  icon: ShieldAlert,
  title: 'Control de Azúcares Ocultos',
  description: 'Identifica y elimina los saboteadores silenciosos de tu dieta.'
}, {
  icon: Moon,
  title: 'Rutina Nocturna Efectiva',
  description: 'Optimiza tu descanso para una recuperación y transformación real.'
}];
export function HabitsSection() {
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-89">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#22C55E]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-90" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-[#F59E0B] font-semibold tracking-wider uppercase text-sm" data-id="element-93">
            El Método
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-white mt-2 mb-6" data-id="element-94">
            Los 5 Micro-Hábitos que <br className="hidden md:block" data-id="element-95" /> Cambiarán
            tu Vida
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-96">
          {habits.map((habit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative p-1 rounded-2xl bg-gradient-to-b from-gray-800 to-gray-900 hover:from-[#22C55E] hover:to-[#22C55E] transition-all duration-500" data-id="element-97">
              <div className="bg-[#0A0A0A] h-full rounded-xl p-8 flex flex-col items-center text-center relative z-10" data-id="element-98">
                <div className="w-16 h-16 rounded-full bg-gray-900 border border-gray-800 flex items-center justify-center mb-6 group-hover:border-[#22C55E]/50 group-hover:bg-[#22C55E]/10 transition-all duration-500" data-id="element-99">
                  <habit.icon className="w-8 h-8 text-gray-400 group-hover:text-[#22C55E] transition-colors duration-500" data-id="element-100" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#22C55E] transition-colors duration-300" data-id="element-101">
                  {habit.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-102">
                  {habit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}